import TileQueueClass, * as TileQueueModule from './../node_modules/ol/TileQueue.js';

// Create a wrapper class
class TileQueue extends TileQueueClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in TileQueueModule) {
    if (key !== "default") {
        TileQueue[key] = TileQueueModule[key];
    }
}

export default TileQueue;

// Re-export ALL named exports from OL
export * from './../node_modules/ol/TileQueue.js';